/* eslint-disable tss-unused-classes/unused-classes */
import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const preferencesModStyles = makeStyles()((theme: Theme) => ({
  container: {
    display: 'flex',
    gap: '15px',
    flexDirection: 'column',
    flexGrow: 1,
  },
  gridContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignContent: 'flex-start',
    minWidth: '550px',
    paddingBottom: '24px',
  },
  containerItem: {
    display: 'flex',
    flexDirection: 'row',
    gap: '26px',
    alignItems: 'center',
  },
  label: {
    fontSize: '12px !important',
    fontWeight: 'bold',
    minWidth: '90px',
  },
  keyFactslabel: {
    fontSize: '12px !important',
    fontWeight: 'bold',
    minWidth: '90px',
    paddingBottom: '24px',
  },
  value: {
    fontSize: '14px !important',
  },
  keyFacts: {
    fontSize: '14px !important',
    paddingBottom: '24px',
  },
  heading: {
    fontSize: '16px !important',
    fontWeight: '500',
    color: '#333333',
  },

  divider: {
    marginTop: '12px',
  },
  headings: {
    fontSize: '16px !important',
    fontWeight: '500',
    color: '#333333',
  },
  headingSpace: {
    marginBottom: '12px',
  },
  tableSpacing: {
    marginTop: '24px',
  },
}));
